import(/* webpackMode: "eager" */ "/vercel/path0/src/app/galeri/page.tsx");
